import { Flex } from '@chakra-ui/react';
import { CalEventContent } from '@/components/shared/interview-scheduler/SchedulerDetails/InterviewCalendar/Components/CalEventContent';

interface MeetingRoomEventContentProps {
  eventInfo: {
    event?: {
      extendedProps?: {
        subject?: string;
      };
    };
  };
}

export const MeetingRoomEventContent: React.FC<
  MeetingRoomEventContentProps
> = ({ eventInfo }) => {
  const subject = eventInfo?.event?.extendedProps?.subject || 'Meeting Room';

  return (
    <Flex bg="gray.100" w="100%" h="100%" p={2} overflow="hidden">
      <CalEventContent
        title={subject}
        colors={{ bg: 'gray.100', color: 'black' }}
      />
    </Flex>
  );
};
